import React from 'react';

export default function Press() {
  const basePath = '/presskit';
  const categories = [
    {
      title: 'Logos',
      folder: 'logos',
      items: [
        'adaptive-icon.png',
        'banner.png',
        'ic_launcher.png'
      ]
    },
    {
      title: 'Screenshots',
      folder: 'screenshots',
      items: [
        'congrats.png',
        'edit-words.png',
        'language-screen-2.jpg',
        'load-words.jpg',
        'pick-n-learn.png',
        'settings-screen.jpg',
        'slide-n-learn-screenshot.jpg',
        'type-n-learn.jpg'
      ]
    },
    {
      title: 'Screenshots from Play Store',
      folder: 'screenshots from play store',
      items: [
        '1-pick-n-learn.jpg',
        '2-pick-n-learn-hints.jpg',
        '3-type-n-learn.jpg',
        '4-slide-n-learn.jpg',
        '5-load-words.jpg',
        '6-choose-languages.jpg',
        '7-edit-words.jpg',
        '8-congrats.jpg'
      ]
    },

  ];

  return (
    <main style={{ maxWidth: 800, margin: '2rem auto', padding: '1rem' }}>
      <h1>Press Kit</h1>
      <p>
        Welcome to the Click-n-Learn press kit. Here you'll find logos, screenshots, app descriptions, and media resources. Click any thumbnail to download the full-resolution file.
      </p>

      <section>
        <h2>App Description</h2>
        <p>
          Click-n-Learn is a lightweight mobile app designed to help users build vocabulary through three quick, game-based activities. It supports ten languages now, with more coming soon. It works offline, and was built aboard a sailboat by a husband-and-wife team passionate about language and travel.
        </p>
        <p>
          Whether you're picking up your first few words or reviewing known vocab, Click-n-Learn makes learning fun, fast, and rewarding.
        </p>
      </section>

      <section>
        <h2>Key Features</h2>
        <ul>
          <li>Three interactive games: Pick-n-Learn, Type-n-Learn, and Slide-n-Learn</li>
          <li>Supports 10 languages: English, French, German, Indonesian, Italian, Japanese, Malay, Mandarin, Spanish, and Thai (More coming soon)</li>
          <li>Offline friendly – no account required</li>
          <li>Distraction-free UI for focused learning</li>
          <li>Optional Text-to-Speech subscription for pronunciation help</li>
        </ul>
      </section>

      {categories.map(({ title, folder, items }) => (
        <section key={title}>
          <h2>{title}</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
            {items.map((filename) => (
              <a
                key={filename}
                href={`${basePath}/${folder}/${filename}`}
                download
                title={`Download ${filename}`}
              >
                <img
                  src={`${basePath}/${folder}/${filename}`}
                  alt={filename}
                  style={{ width: 150, borderRadius: 4, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
                />
              </a>
            ))}
          </div>
        </section>
      ))}

      <section>
        <h2>Videos</h2>
        <ul>
          <li>
            <a href="https://www.youtube.com/watch?v=LYX1lN46SEw" target="_blank" rel="noopener noreferrer">
              Official App Trailer
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/nohEumHcQ_0" target="_blank" rel="noopener noreferrer">
              Learn French Words Fast, The Next Day
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/8tlAH8EMjF0" target="_blank" rel="noopener noreferrer">
              Learn French Words Fast
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/EQG-T2DgPtU" target="_blank" rel="noopener noreferrer">
              How to Talk to a Beautiful Girl—in 5 Languages!
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/PSqr1Br5fZg" target="_blank" rel="noopener noreferrer">
              Learn Some Spanish With A Song for Beginners
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/j4P5pXWQFws" target="_blank" rel="noopener noreferrer">
              The Indonesian Song Experiment
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/E0SBpfHqKvw" target="_blank" rel="noopener noreferrer">
              Going Places with Click-n-Learn 🌍 | 4 Travel Words in 4 Languages
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/XNyW1fDeMxk" target="_blank" rel="noopener noreferrer">
              Click-n-Learn in Action (YouTube Short)
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/shorts/v8YPbFn2w3g" target="_blank" rel="noopener noreferrer">
              Click-n-Learn Demo (YouTube Short)
            </a>
          </li>
        </ul>
      </section>

      <section>
        <h2>Download the App</h2>
        <p>
          <a
            href="https://play.google.com/store/apps/details?id=com.legacyatsea.clicknlearn"
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Click-n-Learn on Google Play Store
          </a>
        </p>
        <p style={{ fontSize: '0.9em', color: '#666', fontFamily: 'monospace' }}>
          https://play.google.com/store/apps/details?id=com.legacyatsea.clicknlearn
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>
          For press inquiries, email us at{' '}
          <a href="mailto:info@click-n-learn.com">info@click-n-learn.com</a>
        </p>
      </section>
    </main>
  );
}
